var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 136,
    viewBox: "0 0 188 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177 0H21C14.9249 0 10 4.91295 10 10.9734V115.051C10 121.111 14.9249 126.024 21 126.024H177C183.075 126.024 188 121.111 188 115.051V10.9734C188 4.91295 183.075 0 177 0Z",
    fill: "#9976BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.1018H178V125.037C178 126.478 177.715 127.905 177.163 129.236C176.61 130.567 175.8 131.777 174.778 132.796C173.757 133.815 172.544 134.623 171.21 135.175C169.875 135.726 168.445 136.01 167 136.01H11C8.08262 136.01 5.28473 134.854 3.22183 132.796C1.15893 130.738 0 127.947 0 125.037L0 28.1018Z",
    fill: "#DFBAF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0495 42.3173H13.7695C13.2172 42.3173 12.7695 42.764 12.7695 43.3149V123.54C12.7695 124.091 13.2172 124.538 13.7695 124.538H68.0495C68.6018 124.538 69.0495 124.091 69.0495 123.54V43.3149C69.0495 42.764 68.6018 42.3173 68.0495 42.3173Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.81 42.3173H80.3398C79.7876 42.3173 79.3398 42.764 79.3398 43.3149V76.9333C79.3398 77.4843 79.7876 77.9309 80.3398 77.9309H163.81C164.362 77.9309 164.81 77.4843 164.81 76.9333V43.3149C164.81 42.764 164.362 42.3173 163.81 42.3173Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M163.81 87.9965H80.3398C79.7876 87.9965 79.3398 88.4431 79.3398 88.994V123.49C79.3398 124.041 79.7876 124.488 80.3398 124.488H163.81C164.362 124.488 164.81 124.041 164.81 123.49V88.994C164.81 88.4431 164.362 87.9965 163.81 87.9965Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30.6157H178V20.9491C178 19.5081 177.715 18.0812 177.163 16.7498C176.61 15.4185 175.8 14.2088 174.778 13.1898C173.757 12.1708 172.544 11.3625 171.21 10.8111C169.875 10.2596 168.445 9.97577 167 9.97577H11C8.08262 9.97577 5.28473 11.1319 3.22183 13.1898C1.15893 15.2477 0 18.0388 0 20.9491L0 30.6157Z",
    fill: "url(#paint0_linear_1311_124965)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0802 112.647C104.019 112.647 117.75 98.9485 117.75 82.0509C117.75 65.1533 104.019 51.4551 87.0802 51.4551C70.1416 51.4551 56.4102 65.1533 56.4102 82.0509C56.4102 98.9485 70.1416 112.647 87.0802 112.647Z",
    fill: "url(#paint1_linear_1311_124965)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0936 95.0639C96.7651 97.3868 93.7984 98.9687 90.5686 99.6096C87.3388 100.251 83.991 99.9216 80.9486 98.6644C77.9062 97.4073 75.3059 95.2784 73.4763 92.5469C71.6468 89.8155 70.6703 86.6042 70.6703 83.3191C70.6703 80.034 71.6468 76.8227 73.4763 74.0912C75.3059 71.3598 77.9062 69.2309 80.9486 67.9737C83.991 66.7166 87.3388 66.3876 90.5686 67.0285C93.7984 67.6694 96.7651 69.2513 99.0936 71.5742",
    stroke: "white",
    strokeWidth: 3.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6914 64.1607L99.0945 71.5744L91.3658 73.3308",
    stroke: "white",
    strokeWidth: 3.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2289 22.8944C11.6648 22.8944 12.8289 21.7332 12.8289 20.3007C12.8289 18.8683 11.6648 17.707 10.2289 17.707C8.79297 17.707 7.62891 18.8683 7.62891 20.3007C7.62891 21.7332 8.79297 22.8944 10.2289 22.8944Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2016 22.8944C22.6375 22.8944 23.8016 21.7332 23.8016 20.3007C23.8016 18.8683 22.6375 17.707 21.2016 17.707C19.7656 17.707 18.6016 18.8683 18.6016 20.3007C18.6016 21.7332 19.7656 22.8944 21.2016 22.8944Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1703 22.8944C33.6063 22.8944 34.7703 21.7332 34.7703 20.3007C34.7703 18.8683 33.6063 17.707 32.1703 17.707C30.7344 17.707 29.5703 18.8683 29.5703 20.3007C29.5703 21.7332 30.7344 22.8944 32.1703 22.8944Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1311_124965",
    x1: -90.5,
    y1: 12.1834,
    x2: 130,
    y2: 12.1834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8627EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BC5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1311_124965",
    x1: 14.5,
    y1: 101.5,
    x2: 112.409,
    y2: 58.2942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.139053,
    stopColor: "#8927EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ABEFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.12b98d7fc6180d3be18b2ed495a3cc3e.svg";
export { ForwardRef as ReactComponent };